import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import {
  chartOptions,
  tradePositionKey,
} from '../../trade-review/trade-review-detail/trade-review-detail-keys';

@Component({
  selector: 'app-holdings-card',
  templateUrl: './holdings-card.component.html',
  styleUrls: ['./holdings-card.component.scss'],
  standalone: false,
})
export class HoldingsCardComponent implements OnInit {
  @Input() chartDetails;
  private changeDetector = inject(ChangeDetectorRef);
  tradePositionKey = tradePositionKey;
  selectedHoldingTab = 0;
  chartSelection = 'PT';
  chartOptions = chartOptions;
  updateFlag = false;
  primaryAlerts = [];
  otherAlerts = [];
  showOtherAlerts = false;

  ngOnInit(): void {
    if (this.chartDetails['Chart_Acct_PT']) {
      this.chartOptions.series.push({
        data: this.chartDetails['Chart_Acct_PT'],
        name: 'Amount',
        type: 'pie',
      });
      this.updateFlag = true;
    }
    if (
      !this.chartDetails.DisplayFX?.['ShowAccountPositionsTabFX'] &&
      this.chartDetails.DisplayFX?.['ShowClientPositionsTabFX']
    ) {
      this.selectedHoldingTab = 1;
    } else if (
      !this.chartDetails.DisplayFX?.['ShowAccountPositionsTabFX'] &&
      !this.chartDetails.DisplayFX?.['ShowClientPositionsTabFX'] &&
      this.chartDetails.DisplayFX?.['ShowHouseholdPositionsTabFX']
    ) {
      this.selectedHoldingTab = 2;
    }
    this.getChartData();
  }

  objMissingValue(obj, value) {
    if (typeof obj !== 'object') {
      return true;
    }
    const objKeys = Object.keys(obj);
    return !objKeys.includes(value);
  }

  changeHoldingTab(ev) {
    this.selectedHoldingTab = ev.index;
    this.getChartData();
  }

  changeChartSelection(ev) {
    this.chartSelection = ev.value;
    this.getChartData();
  }

  getChartData() {
    this.updateFlag = false;
    this.chartOptions.series = [];
    let translatedHoldingTab = 'Acct';
    if (this.selectedHoldingTab === 1) {
      translatedHoldingTab = 'Client';
    } else if (this.selectedHoldingTab === 2) {
      translatedHoldingTab = 'House';
    }

    this.chartOptions.series[0] = {
      data: this.chartDetails[
        `Chart_${translatedHoldingTab}_${this.chartSelection}`
      ],
      type: 'pie',
    };
    this.changeDetector.detectChanges();
    this.updateFlag = true;
  }

  showChart() {
    let translatedHoldingTab = 'Acct';

    if (this.selectedHoldingTab === 1) {
      translatedHoldingTab = 'Client';
    } else if (this.selectedHoldingTab === 2) {
      translatedHoldingTab = 'House';
    }

    let datapointCheck = '';

    if (
      this.chartDetails[`Chart_${translatedHoldingTab}_${this.chartSelection}`]
        .length < 1
    ) {
      datapointCheck = 'hide';
    } else if (
      this.chartDetails[`Chart_${translatedHoldingTab}_${this.chartSelection}`]
        .length === 1
    ) {
      this.chartDetails[
        `Chart_${translatedHoldingTab}_${this.chartSelection}`
      ].map(chartpoint => {
        if (chartpoint.y === 0 && chartpoint.name === '') {
          datapointCheck = 'hide';
        }
      });
    } else {
      let emptyDataCount = 0;
      this.chartDetails[
        `Chart_${translatedHoldingTab}_${this.chartSelection}`
      ].map(chartpoint => {
        if (chartpoint.y === 0 && chartpoint.name === '') {
          emptyDataCount = emptyDataCount + 1;
        }
      });

      if (
        emptyDataCount >=
        this.chartDetails[
          `Chart_${translatedHoldingTab}_${this.chartSelection}`
        ].length
      ) {
        datapointCheck = 'hide';
      }
    }

    return datapointCheck;
  }
}
